import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';

/**
 *
 * @returns The file download url
 */
const uploadSingleFileToStorage = async (storage, refPath, file) => {
  try {
    
    if (!storage?.instance) {
      throw new Error('Storage instance not available. Make sure Firebase Storage is properly initialized.');
    }
    
    
    if (!refPath) {
      throw new Error('Reference path is required');
    }
    
    if (!file) {
      throw new Error('File is required');
    }
    
    const storageRef = ref(storage.instance, refPath);
    
    const snapshot = await uploadBytes(storageRef, file);
    
    const url = await getDownloadURL(snapshot.ref);
    
    return url;
  } catch (error) {
    throw error;
  }
};

export default uploadSingleFileToStorage;